/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./newGlobalControl.vue?vue&type=template&id=2072d304&scoped=true&"
import script from "./newGlobalControl.vue?vue&type=script&lang=js&"
export * from "./newGlobalControl.vue?vue&type=script&lang=js&"
import style0 from "./newGlobalControl.vue?vue&type=style&index=0&id=2072d304&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072d304",
  null
  
)

export default component.exports